// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"621":"44ab833b","780":"44ab833b"}[chunkId] + ".css";
};